

// const accountInfoResponse = await getAccountInfo(clientId);

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccount, getAccountSummary, getClientAccountTree } from "../../api/request/dashboard/dashboard";
import { setAccountData } from "../Slices/accountSummary";
import { setUserDetails } from "../Slices/userSlice";
import { addJournalLog } from "../../components/tab/tabview/journal/addJournalLog";
import { clearPL, profitLoss } from "../../components/footer/AccountFooter";
import { updateProfitLoss } from "../Slices/profitLossSlice";

export const GetAccount = createAsyncThunk('account/get', async ({ accountId }, { dispatch, getState, rejectWithValue }) => {
    try {
        const username = localStorage.getItem('username')
        const clientId = getState().user?.userDetail?.id

        clearPL();
        console.log("✅ Cleared profitLoss:", [...profitLoss]);
        dispatch(updateProfitLoss(Date.now()));

        const response = await getAccount(accountId);
        document.title = `${accountId} - Equitas Trader`
        localStorage.setItem("accountID", accountId);
        dispatch(setAccountData(response?.data || {}));
        localStorage.setItem(`SelectedAccount_${clientId}`, accountId)

        addJournalLog('login', `Account ${username}: ${accountId} is logged in successfully.`);
        return accountId;
    } catch (err) {
        console.log('inside catch ', err);
        // try {
        //     console.log('inside catch ');

        //     const username = localStorage.getItem('username')
        //     // profitLoss.clear();
        //     clearPL();
        //     console.log("✅ Cleared profitLoss:", [...profitLoss]);
        //     dispatch(updateProfitLoss(Date.now()));
        //     const res = await getAccount(defaultAccount);
        //     document.title = `${defaultAccount} - Vertexfx Trader`
        //     dispatch(setAccountData(res?.data || {}));
        //     localStorage.setItem("SelectedAccount", defaultAccount)
        //     localStorage.setItem("accountID", defaultAccount);
        //     addJournalLog('login', `Account ${username}: ${defaultAccount} is logged in successfully.`);
        //     return defaultAccount;
        // } catch (err) {
        rejectWithValue(err)
        // }
    }
})

export const fetchAccountTree = createAsyncThunk('accountTree/get', async (acData = false, { getState, rejectWithValue, dispatch }) => {
    try {

        // const clientId = getState().user?.userDetail?.id 
        const clientId = localStorage.getItem('clientId') || getState().user?.userDetail?.id
        const { data } = await getClientAccountTree(clientId);
        console.log('data', data);

        if (Array.isArray(data)) {
            for (const item of data) {
                console.log(Object.keys(item.accounts))
                const accounts = Object.keys(item.accounts)
                if (accounts.length && !acData) {
                    const account = localStorage.getItem(`SelectedAccount_${clientId}`)
                    console.log(account == null,account)
                    dispatch(GetAccount({ accountId: account != null ? account : accounts[0], }));
                    dispatch(setUserDetails(item?.client))
                    break;
                }
            }
            return data;
        } else {
            console.warn("Unexpected API response format:", data);
            return []
        }
    } catch (err) {

    }
})

export const fetchAccountSummary = createAsyncThunk('accountSummary/get', async (accountId, { getState }) => {
    try {
        const { data } = await getAccountSummary(accountId);
        return data || {};
    } catch (err) {
        return {};
    }
})